<template>
  <div class="flex align-center justify-center overlay">
    <transition name="fadeScale">
      <div v-if="dialog"
           class="window no--sb oval transition overflow-hidden relative"
           :class="{active: dialog}">
        <div class="flex justify-center align-center header">
          <h3 class="title text-center">{{ dialogTitle }}</h3>
          <button v-if="!subDialog.visible" @click="toggleDialog(false)" class="transition pointer">
            <img src="../../assets/svg/close.svg" alt="close button">
          </button>
        </div>
        <div class="content tab2SpecH">
          <di-type1 :stepData="currentStepData[currentRoute]" v-if="type1.includes(currentRoute)" />
          <di-type2 :stepData="currentStepData[currentRoute]" v-else-if="type2.includes(currentRoute)" />
          <di-type3 :stepData="currentStepData[currentRoute]" v-else-if="type3.includes(currentRoute)" />
          <di-type4 :stepData="currentStepData[currentRoute]" v-else-if="type4.includes(currentRoute)" />
          <di-type5 :stepData="currentStepData[currentRoute]" v-else-if="type5.includes(currentRoute)" />
          <di-type6 :stepData="currentStepData[currentRoute]" v-else-if="type6.includes(currentRoute)" />
        </div>

        <transition name="fade">
          <sub-dialog v-if="subDialog.visible" :class="{}">
            <button @click="toggleSubDialog(null, false)" class="transition pointer">
              <img src="../../assets/svg/close.svg" alt="close button">
            </button>
            <!--  basic step image load  -->
            <img v-if="applyRule(subDialog.data.val).visible && subDialog.data && currentRoute!=='step7' && currentRoute!=='step8' " class="sub-dialog-image oval" :src="currentImage(subDialog.data)" alt="sub dialog image">
            <!--  dynamic step image load  -->
            <img v-if="applyRule(subDialog.data.val).visible && currentRoute === 'step7'" class="sub-dialog-image oval pointer" :src="currentImage(subDialog.data).forDialogue" alt="image">
            
            <div v-else-if="!applyRule(subDialog.data.val).visible" class="relative substitute">
              <img v-if="currentRoute=='step2' || currentRoute=='step3' || currentRoute=='step4' || currentRoute=='step5' || currentRoute=='step6' ||currentRoute=='step9'" :src="currentImage(subDialog.data)" alt="substitute image">
              <img v-if="currentRoute=='step7'" :src="currentImage(subDialog.data).forDialogue" alt="substitute image">
              <img v-if="!currentRoute=='step2' && !currentRoute=='step3' && !currentRoute=='step4' && !currentRoute=='step5' && !currentRoute=='step7' && !currentRoute=='step9'" :src="applyRule(subDialog.data.val).ring" alt="substitute image">
              <img v-if="!currentRoute=='step2' && !currentRoute=='step3' && !currentRoute=='step4' && !currentRoute=='step5' && !currentRoute=='step7' && !currentRoute=='step9'" class="oval pointer absolute idx1" :src="currentImage(subDialog.data).base" alt="image">
              <img v-if="!currentRoute=='step2' && !currentRoute=='step3' && !currentRoute=='step4' && !currentRoute=='step5' && !currentRoute=='step7' && !currentRoute=='step9' && !['hoshibori', 'taiyobori'].includes(subDialog.data.val)" class="oval pointer absolute idx2" :src="currentImage(subDialog.data).diamond" alt="image">
            </div>


            <h4 class="title">{{subDialog.data.name}}</h4>
            <p class="content">{{subDialog.data.summary}}</p>
          </sub-dialog>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import {computed, ref, watch} from "vue";
import {useStore} from "vuex";
import useDialogBuilder from "@/modules/moduleA/helpers/useDialogBuilder";
import useImageBuilder from "@/modules/moduleA/helpers/useImageBuilder";
import useRules from "@/modules/moduleA/helpers/useRules";
import DiType1 from "@/modules/moduleA/components/dialogs/DiType1";
import DiType2 from "@/modules/moduleA/components/dialogs/DiType2";
import DiType3 from "@/modules/moduleA/components/dialogs/DiType3";
import SubDialog from "@/modules/moduleA/components/dialogs/SubDialog";
import DiType4 from "@/modules/moduleA/components/dialogs/DiType4";
import DiType5 from "@/modules/moduleA/components/dialogs/DiType5";
import DiType6 from "@/modules/moduleA/components/dialogs/DiType6";
import {PATH_HANDLER} from "@/config";

export default {
  name: "AppDialog",
  components: {DiType6, DiType5, DiType4, DiType3, DiType1, DiType2, SubDialog, },
  props:{
    step:{String},
  },
  setup(props){
    const store = useStore()
    const {currentRoute, currentStepData, selectedItem, detailItem, toggleDialog, toggleSubDialog} = useDialogBuilder()
    const {currentImage} = useImageBuilder(currentRoute.value)
    const {applyRule} = useRules(currentRoute.value)
    const url = PATH_HANDLER.path+"/images/"


    watch(() => detailItem.value, (val) => {
      console.log(val)
    })

    const dialog = computed(() => {
      return store.state.dialog
    })
    const subDialog = computed(() => {
      return store.state.subDialog
    })

    const step2SubDialogImg = (data) => {
      return url + "step2/man/" + data.val + ".jpg"
    }


    const dialogTitle = computed(() => {
      if (props.step === "Step1"){return "地金をお選びください"}
      else if (props.step === "Step2"){return "リングのかたちをお選びください"}
      else if (props.step === "Step3"){return "テクスチャーをお選びください"}
      else if (props.step === "Step4"){return "表面の仕上げをお選びください"}
      else if (props.step === "Step5"){return "リング幅をお選びください"}
      else if (props.step === "Step6"){return "ミルグレインをお入れしますか"}
      else if (props.step === "Step7"){return "外側にダイヤモンドをお留めしますか"}
      else if (props.step === "Step8"){return "内石をお選びください"}
      else if (props.step === "Step9"){return "リングの内側に刻印する"}
      else {}
    })

    const type1 = ref(["step1", "step2"])
    const type2 = ref(["step3", "step4", "step6"])
    const type3 = ref(["step5"])
    const type4 = ref(["step7"])
    const type5 = ref(["step8"])
    const type6 = ref(["step9"])


    return {currentRoute, currentStepData, currentImage, selectedItem, detailItem, toggleDialog, toggleSubDialog, dialog, subDialog,
      type1, type2, type3, type4, type5, type6, applyRule, dialogTitle,step2SubDialogImg}
  }

}
</script>

<style scoped>
.overlay {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0,0,0,.3);
}
.overlay > .window {
  width: 95%;
  max-width: 1000px;
  height: 100%;
  max-height: 90%;
  background-color: white;
  box-shadow: 0 1px 2px rgba(0,0,0,0.07),
              0 2px 4px rgba(0,0,0,0.07),
              0 4px 8px rgba(0,0,0,0.07),
              0 8px 16px rgba(0,0,0,0.07),
              0 16px 32px rgba(0,0,0,0.07),
              0 32px 64px rgba(0,0,0,0.07);
}
.overlay > .window > .header {
  position: relative;
  width: 100%;
  height: 70px;
  padding: 0 20px;
  border-bottom: 1px solid #f5f6fa;
}
.overlay > .window > .header > h3.title {
  position: absolute;
  left: 50%;
  width: 100%;
  font-weight: 400;
  font-size: 1.2rem;
  top: 50%;
  transform: translate(-50%, -50%);
}
.overlay > .window > .header > button {
  margin-left: auto;
  height: 40px;
  width: 40px;
}
.overlay > .window > .header > button:hover {
  background-color: whitesmoke;
  border-radius: 14px;
}
.overlay > .window > .header > button > img {
  position: relative;
  top: 2px;
  width: 20px;
  height: 20px;
}
.overlay > .window > .content {
  height: calc(100% - 90px)
}

</style>
